import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCorporateAvailabilityIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.5 11.125H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 11.8849 3 12.1649 3 12.725v8.4m13.5-10h2.9c.5601 0 .8401 0 1.054.109a1 1 0 0 1 .437.437c.109.2139.109.4939.109 1.054v8.4m-4.5 0v-14.8c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874c-.4278-.218-.9879-.218-2.108-.218h-2.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C7.5 4.6448 7.5 5.205 7.5 6.325v14.8m14.5 0H2m9-14h2m-2 4h2m-2 4h2"
    />
  </svg>
);
export default SvgCorporateAvailabilityIcon;
